import CostCenterCreateComponent from './cost_center.create.component';

let CostCenterCreateModule = angular.module('costCenterCreate', [])
    .component('costCenterCreate', CostCenterCreateComponent)
    .name;

export default CostCenterCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/create/index.js